import { orderBy } from 'lodash';

const listConfigurations = [
  'all',
  'approbed_ad',
  'approbed_univ',
  'automatic_unpublished',
  'background_check_completed',
  'canceled_vacancy',
  'assessment_delete',
  'confirmed_interviu',
  'covered_vacancy',
  'email_postulant',
  'finaly_applicant',
  'finaly_credit',
  'finaly_postulant_ref',
  'finaly_postulant_spontaneus',
  'finaly_postulant',
  'new_postulant_feed',
  'new_ref_vac',
  'new_referency_ref',
  'rejected_ad',
  'rejected_univ',
  'solicite_accept_lead',
  'solicite_accept_postul',
  'solicite_ignore_lead',
  'solicite_ignore_postul',
  'solicite_new_lead',
  'solicite_new_postul',
  'suspended_ad',
  'suspended_univ',
  'update_profile',
  'user_process_added',
  'suiteOn',
  'suiteOff',
  'vacancy_notification_created',
  'vacancy_requisition',
  'integrations'
];
const configurations = new Map([
  ['hr-Person', ['finaly_postulant', 'finaly_postulant_spontaneus']],
  ['hr-Magnet', ['finaly_postulant_ref', 'new_ref_vac']],
  ['hr-email', ['email_postulant']],
  ['hr-Calendar', ['finaly_applicant', 'confirmed_interviu']],
  ['hr-Money', ['finaly_credit']],
  [
    'hr-Close',
    [
      'canceled_vacancy',
      'assessment_delete',
      'solicite_ignore_lead',
      'solicite_ignore_postul',
      'automatic_unpublished',
      'rejected_univ',
      'rejected_ad',
      'suiteOff'
    ]
  ],
  [
    'hr-Checkmark',
    ['covered_vacancy', 'solicite_accept_lead', 'solicite_accept_postul', 'approbed_univ', 'approbed_ad', 'suiteOn']
  ],
  ['hr-Request', ['new_postulant_feed', 'new_referency_ref', 'vacancy_notification_created', 'mention']],
  ['hr-Invite', ['solicite_new_postul', 'solicite_new_lead']],
  ['hr-Pause', ['suspended_univ', 'suspended_ad']],
  ['hr-Story', ['update_profile']],
  ['hr-Plus', ['user_process_added']],
  ['hr-Verificante', ['background_check_completed']]
]);

export const getIcon = (find) => {
  for (const [key, value] of configurations.entries()) {
    if (value.indexOf(find) !== -1) return key;
  }
};

const configurationsActions = new Map([
  ['hr-Solicit', ['create']],
  ['hr-Checkmark', ['approve', 'offer_publication_success']],
  ['hr-Close', ['disapprove', 'offer_publication_problem', 'user_problem']],
  ['hr-Pencil', ['modify']],
  ['hr-Trash', ['delete']],
  ['hr-Story', ['updated']]
]);

export const getIconAction = (action) => {
  for (const [key, value] of configurationsActions.entries()) {
    if (value.indexOf(action) !== -1) return key;
  }
};

const colors_ = new Map([
  [
    '#3B3F51',
    [
      'finaly_postulant',
      'finaly_postulant_spontaneus',
      'finaly_postulant_ref',
      'email_postulant',
      'finaly_applicant',
      'finaly_credit',
      'new_ref_vac',
      'new_postulant_feed',
      'solicite_new_lead',
      'solicite_new_postul',
      'suspende_univ',
      'update_profile',
      'suspende_ad',
      'user_process_added',
      'new_referency_ref',
      'vacancy_notification_created',
      'suspended_univ',
      'mention',
      'background_check_completed'
    ]
  ],
  [
    '#24BB72',
    [
      'suiteOn',
      'confirmed_interviu',
      'covered_vacancy',
      'solicite_accept_lead',
      'solicite_accept_postul',
      'approbed_ad',
      'approbed_univ'
    ]
  ],
  [
    '#ED6B75',
    [
      'canceled_vacancy',
      'assessment_delete',
      'solicite_ignore_lead',
      'solicite_ignore_postul',
      'automatic_unpublished',
      'suspended_ad',
      'suiteOff',
      'rejected_univ',
      'rejected_ad'
    ]
  ]
]);

export const getColorIcon = (find) => {
  for (const [key, value] of colors_.entries()) {
    if (value.indexOf(find) !== -1) return key;
  }
};

const colorsActions_ = new Map([
  ['#3B3F51', ['create', 'updated']],
  ['#24BB72', ['approve', 'offer_publication_success']],
  ['#ED6B75', ['disapprove', 'offer_publication_problem', 'user_problem']],
  ['#F69708', ['modify']],
  ['#767676', ['delete']]
]);

export const getColorIconAction = (find) => {
  for (const [key, value] of colorsActions_.entries()) {
    if (value.indexOf(find) !== -1) return key;
  }
};

export const selectOptionsTypeNotifications = (t) => {
  // iterar por las opciones de list configuraciones y devolverlas en un array
  const options = [];
  listConfigurations.forEach((item) => {
    options.push({
      value: item,
      label: t(`notifications.selectOptions.${item}`)
    });
  });
  console.log(options);

  // multiple order by label and value is equal to order by label
  return orderBy(options, [(i) => i.value === 'all', 'label'], ['desc', 'asc']);
};
